import { z } from "zod";

// A blank value retains the stored one on the server, so it is left out.
export const credentialsOf = values =>
  Object.fromEntries(
    ["api_key", "api_secret"]
      .map(name => [name, values?.[name]])
      .filter(([, value]) => value)
  );

export const sameCredentials = (a, b) =>
  a?.api_key === b?.api_key && a?.api_secret === b?.api_secret;

// Typed credentials are only known to work once Swoogo accepted them, either in
// a test or in a save. `acceptedCredentials` lists those.
export const isSaveBlocked = ({ isStored, acceptedCredentials, values }) => {
  const typed = credentialsOf(values);
  const isTyped = Object.keys(typed).length > 0;
  if (!isTyped) {
    return !isStored;
  }
  return !acceptedCredentials.some(accepted =>
    sameCredentials(typed, accepted)
  );
};

export const makeSchema = isStored =>
  z.object({
    account_name: z.string().trim().min(1, "Account name is required"),
    api_key: isStored
      ? z.string().optional()
      : z.string().min(1, "Consumer key is required"),
    api_secret: isStored
      ? z.string().optional()
      : z.string().min(1, "Consumer secret is required"),
    folder_ids: z.array(z.number()),
  });
